module.exports = __webpack_public_path__ + "img/entertainment-bar-carts-cabinets.30ab387.jpg";